const localDataName = 'mateInvoice';
const orderStatusOptions = ['Pending', 'Shipped', 'Delivered'];


const newInvoice = {
  orderStatus: 'Pending',
  fecha: new Date().getTime(),
  currency: '$',
  billTo: '',
  billToAddress: '',
  billFrom: 'Códice SAS',
  billFromAddress: 'facturacion@codice.com\nCra 5 123, Pereira, Risaralda,\nTeléfono: +(402) 748-3970',
  invoiceList: [
    {
      key: 1,
      itemName: '',
      costs: 0,
      qty: 0,
      price: 0,
    },
  ],
  subTotal: 0,
  vatRate: 19,
  vatPrice: 0,
  totalCost: 0,
};


export {
  localDataName,
  newInvoice,
  orderStatusOptions,
};
